import { isFamilyRootBlock, isPersonalRootBlock } from './constants';
import type { BlockRecord } from './types';

export type WorkspaceRootKind = 'family' | 'personal';

export function workspaceRootKind(
  block: BlockRecord,
  memberId: string,
): WorkspaceRootKind | null {
  if (isFamilyRootBlock(block)) {
    return 'family';
  }
  if (isPersonalRootBlock(block, memberId)) {
    return 'personal';
  }
  return null;
}
